import { showErrorNotification } from '../../global/notifications';
import { loadPlanAssignmentList } from './plan-assignment-list';

export default function () {
    _$loadingSpinner = $('#LoadingTopic');
    _$noEmployeeSelectedTopic = $('#NoEmployeeSelected');
    _$planAssignmentListTopic = $('#PlanAssignmentList');
    _$planAssignmentTopic = $('#PlanAssignment');
    _$planBuilderTopic = $('#CommissionBuilderPane');

    initializeEmployeeSelect();
}

let _selectedEmployee = null;
let _selectedPlanAssignmentId = null;
let _$loadingSpinner = null;
let _$noEmployeeSelectedTopic = null;
let _$planAssignmentListTopic = null;
let _$planAssignmentTopic = null;
let _$planBuilderTopic = null;

function initializeEmployeeSelect() {
    const dropdownData = new kendo.data.DataSource({
        serverFiltering: false, transport: {
            read: {
                type: 'get', url: '/Commissions/CommissionPlanAssignment/GetEmployeeList'
            }
        }
    });

    $('#employee-select').kendoDropDownList({
        optionLabel: ' ', dataTextField: 'EmployeeName', filter: 'contains', dataSource: dropdownData, width: '100%', select: onEmployeeSelected
    });

    function onEmployeeSelected(event) {
        startLoading();
        _$planBuilderTopic.hide();
        _selectedEmployee = event.dataItem.EmployeeNumber != null ? event.dataItem : null;

        if (_selectedEmployee == null) {
            showNoEmployeeSelectedSection();
            endLoading();
            return;
        }

        loadPlanAssignmentList(_selectedEmployee)
            .then(endLoading)
            .then(showPlanAssignmentListSection)
            .catch(error => showErrorNotification(error));
    }
}

function startLoading() {
    _$loadingSpinner.show();
    _$noEmployeeSelectedTopic.hide();
    _$planAssignmentTopic.hide();
    _$planBuilderTopic.hide();
}

function endLoading() {
    _$loadingSpinner.hide();
}

function showNoEmployeeSelectedSection() {
    _$noEmployeeSelectedTopic.show();
    _$planAssignmentTopic.hide();
    _$planBuilderTopic.hide();
}

function showPlanAssignmentListSection() {
    _$noEmployeeSelectedTopic.hide();
    _$planAssignmentListTopic.show();
}
